export type ChartMarker = {
  value: number;
  label: string;
};

const PILL_HEIGHT = 20;
const PILL_PADDING_X = 10;
const CHAR_WIDTH = 6.6;
const TEXT_OFFSET = 16;

const pillWidthFor = (label: string) =>
  Math.max(76, Math.ceil(label.length * CHAR_WIDTH) + PILL_PADDING_X * 2);

export const ChartAverageMarker = ({
  marker,
  y,
  xMax,
}: {
  marker: ChartMarker;
  y: number;
  xMax: number;
}) => {
  const pillWidth = pillWidthFor(marker.label);

  return (
    <g style={{ pointerEvents: 'none' }}>
      <line x1={0} x2={xMax} y1={y} y2={y} stroke="#CDCDCD" strokeWidth={1} strokeDasharray="2" />
      <g transform={`translate(0, ${y - PILL_HEIGHT / 2 - TEXT_OFFSET})`}>
        <rect
          width={pillWidth}
          height={PILL_HEIGHT}
          rx={PILL_HEIGHT / 2}
          ry={PILL_HEIGHT / 2}
          fill="#252525"
          stroke="#424242"
          strokeWidth={1}
        />
        <text
          x={pillWidth / 2}
          y={PILL_HEIGHT / 2}
          fill="#CDCDCD"
          fontSize={12}
          fontFamily="Aeonik-Medium"
          textAnchor="middle"
          alignmentBaseline="middle"
        >
          {marker.label}
        </text>
      </g>
    </g>
  );
};
